import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {snackbarAction} from "../../../errors/SnackbarSlice";
import {IForgotPasswordReject} from "./fetchRequestPasswordReset.types";

interface IRequestPasswordResetArgs {
    email: string
}

export const fetchRequestPasswordReset = createAsyncThunk<void,
    IRequestPasswordResetArgs, ThunkConfig<IForgotPasswordReject>>(
        'auth/fetchRequestPasswordReset',
        async (args, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.post(
                    `/auth/request-password-reset`,
                    {email: args.email});

                if (!response.data.success) {
                    const codeKey = response.data.codeKey;

                    if (codeKey === 'NOT_VALID' && response.data.response?.errors?.email) {
                        return rejectWithValue({
                            emailError: response.data.response.errors.email
                        })
                    }

                    return rejectWithValue({error: codeKey})
                }
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue({error: 'INTERNAL_ERROR'});
            }
        },
    );
